import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useLanguageStore = defineStore('language', () => {
  const locale = ref(localStorage.getItem('exotrack_locale') || 'en')

  const applyDirection = (lang) => {
    const html = document.documentElement
    if (lang === 'ar') {
      html.setAttribute('dir', 'rtl')
      html.setAttribute('lang', 'ar')
    } else {
      html.setAttribute('dir', 'ltr')
      html.setAttribute('lang', 'en')
    }
  }

  // Apply on load
  applyDirection(locale.value)

  watch(locale, (lang) => {
    localStorage.setItem('exotrack_locale', lang)
    applyDirection(lang)
  })

  const setLocale = (lang) => { locale.value = lang }
  const toggle   = () => { locale.value = locale.value === 'en' ? 'ar' : 'en' }
  const isArabic = () => locale.value === 'ar'

  return { locale, setLocale, toggle, isArabic }
})
